export default "__VITE_ASSET__a824c38f__"